module.exports = __webpack_public_path__ + "img/logo.d0017966.png";